import './App.css';
import CustomerDetails from './components/Customer';

function App() {
  return (
    <>
      <CustomerDetails/>
    </>
  );
}

export default App;
